/**
 * Created by r4zi4l on 17.09.2021
 */

const IngredientOrderIcon = cc.Node.extend({
    ctor: function (ingredient, maker, options) {
        const styles = cleverapps.styles.IngredientOrderIcon;
        this._super();

        this.ingredient = ingredient;
        this.maker = maker;
        this.options = options || {};

        this.needed = ingredient && ingredient.amount || 0;

        if (this.ingredient && this.maker && this.maker.getState() === Customer.STATE_RECIPE) {
            this.amount = Map2d.currentMap.stock.getStockAmount(this.ingredient);
        }

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(styles);

        this.contentRect = cc.rectSubPadding(cc.rect(0, 0, this.width, this.height), cc.padding(styles.padding));

        if (this.ingredient) {
            const icon = this.icon = CustomerRecipe.getIngredientIcon(this.ingredient);

            if (this.ingredient.unit && this.ingredient.unit.code && Families[this.ingredient.unit.code].missionType) {
                const help = this.help = new cc.Sprite(bundles.extended_customer_view.frames.customer_order_help);

                cleverapps.UI.onClick(help, () => {
                    const window = cleverapps.focusManager.currentWindow();
                    if (window) {
                        window.close();
                    }
                    Mineable.FindMissionSource(Families[this.ingredient.unit.code].missionType);
                }, { swallowEvents: true });

                help.setAlignment(styles.icon.help);
                icon.addChild(help);
                help.setVisible(false);
            }

            if (this.options.iconScale) {
                icon.setScale(this.options.iconScale);
            } else {
                cleverapps.UI.fitToBox(icon, {
                    width: this.contentRect.width,
                    height: this.contentRect.height,
                    maxScale: styles.icon.scale
                });
            }

            if (this.options.iconPos) {
                icon.setAlignment(this.options.iconPos);
            } else {
                icon.setAlignment(this.contentRect.x + this.contentRect.width / 2, this.contentRect.y + this.contentRect.height / 2);
            }

            this.addChild(icon);
        }

        this.createText();
        this.createCheckmark();
        this.setRecCascadeColorEnabled(true);
        this.setCascadeOpacityEnabledRecursively(true);

        this.setEnabled(!this.amount || this.amount >= this.needed);
    },

    createText: function (hideAmount) {
        if (!this.amount && !this.needed) {
            return;
        }

        let simpleTextPos;

        if (this.options.simpleText) {
            if (this.amount < this.needed) {
                this.amountTxt = cleverapps.UI.generateImageText(this.amount, cleverapps.styles.FONTS.INGREDIENT_ORDER_ICON_SIMPLE_MISSING_TEXT);
            }
            this.neededTxt = cleverapps.UI.generateImageText(this.amountTxt ? `/${this.needed}` : `${this.needed}`, cleverapps.styles.FONTS.INGREDIENT_ORDER_ICON_SIMPLE_TEXT);
            simpleTextPos = cleverapps.styles.IngredientOrderIcon.simpleTextPos;
        } else if (this.amount === undefined || hideAmount) {
            this.neededTxt = cleverapps.UI.generateImageText(`x${this.needed}`, cleverapps.styles.FONTS.INGREDIENT_ORDER_ICON_TEXT);
        } else {
            this.amountTxt = cleverapps.UI.generateImageText(this.amount, cleverapps.styles.FONTS.INGREDIENT_ORDER_ICON_TEXT);
            this.neededTxt = cleverapps.UI.generateImageText(`/${this.needed}`, cleverapps.styles.FONTS.INGREDIENT_ORDER_ICON_TEXT);
        }

        this.textNode = new cleverapps.Layout([this.amountTxt, this.neededTxt].filter(Boolean), {
            direction: cleverapps.UI.HORIZONTAL,
            margin: 0
        });
        this.textNode.setLocalZOrder(2);
        cleverapps.UI.fitToBox(this.textNode, { width: this.contentRect.width, height: this.contentRect.height, maxScale: 1 });
        this.textNode.setAnchorPoint(1, 0);
        this.textNode.setAlignment(simpleTextPos || { x: this.contentRect.x + this.contentRect.width, y: this.contentRect.y });
        this.addChild(this.textNode);
    },

    createCheckmark: function () {
        if (!this.options.checkmark) {
            return;
        }

        this.checkmark = new cc.Sprite(this.options.checkmark);
        this.checkmark.setAlignment(cleverapps.styles.IngredientOrderIcon.checkMark);
        this.checkmark.setVisible(false);
        this.addChild(this.checkmark);
    },

    setEnabled: function (enabled) {
        enabled = this.ingredient && enabled;

        [this.icon, this.amountTxt, this.neededTxt].forEach((node) => {
            if (!node) {
                return;
            }
            if (enabled) {
                node.setOpacity(255);
                node.setColor(new cc.Color(255, 255, 255, 255));
                if (node === this.amountTxt && this.amount >= this.needed) {
                    node.setColor(cleverapps.styles.COLORS.GREEN);
                }
            } else if (!this.options.noGrayEffect) {
                node.setOpacity(200);
                node.setColor(new cc.Color(180, 180, 180, 255));
            }
        });

        const showCheckmark = enabled && this.amount >= this.needed;

        if (this.checkmark) {
            this.checkmark.setVisible(showCheckmark);
        }
        if (this.help) {
            this.help.setVisible(!showCheckmark);
        }
    },

    beforeRemoveAnimated: function () {
        this.setEnabled(true);
        if (this.text) {
            this.text.removeFromParent();
            delete this.text;
        }
    },

    updateAmount: function (options) {
        if (!this.ingredient) {
            return;
        }

        options = options || {};

        const newAmount = Map2d.currentMap.stock.getStockAmount(this.ingredient);
        if (this.amount === newAmount) {
            return;
        }

        const delta = newAmount - this.amount;
        this.amount = newAmount;

        if (this.icon) {
            this.icon.runAction(new cc.Sequence(
                new cc.CallFunc(() => {
                    if (this.amount && this.amountTxt) {
                        this.amountTxt.setString(this.amount);
                    }
                    if (!options.hideDelta) {
                        cleverapps.aims.showDelta(delta, this, {
                            font: cleverapps.styles.FONTS.INGREDIENT_ORDER_ICON_TEXT
                        });
                    }
                }),
                new cc.ScaleTo(0.3, this.icon.scale * 1.1).easing(cc.easeIn(2)),
                new cc.CallFunc(() => {
                    if (this.textNode) {
                        delete this.amountTxt;
                        delete this.neededTxt;
                        this.textNode.removeFromParent();
                        this.createText(delta < 0);
                        this.setEnabled(true);
                    }
                }),
                new cc.ScaleTo(0.3, this.icon.scale * 1).easing(cc.easeOut(2)),
                new cc.ScaleTo(0.2, this.icon.scale * 1.05).easing(cc.easeIn(2)),
                new cc.ScaleTo(0.2, this.icon.scale * 1).easing(cc.easeOut(2))
            ));
        }
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    INGREDIENT_ORDER_ICON_TEXT: {
        size: 44,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        shadow: cleverapps.styles.COLORS.LIGHT_TEXT_SHADOW,
        stroke: cleverapps.styles.COLORS.LIGHT_TEXT_STROKE
    },

    INGREDIENT_ORDER_ICON_SIMPLE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        shadow: cleverapps.styles.COLORS.LIGHT_TEXT_SHADOW,
        stroke: cleverapps.styles.COLORS.LIGHT_TEXT_STROKE
    },

    INGREDIENT_ORDER_ICON_SIMPLE_MISSING_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.MESSAGE_RED,
        shadow: cleverapps.styles.COLORS.LIGHT_TEXT_SHADOW,
        stroke: cleverapps.styles.COLORS.LIGHT_TEXT_STROKE
    }
});

cleverapps.styles.IngredientOrderIcon = {
    width: 160,
    height: 140,

    padding: {
        x: 8,
        y: 2
    },

    icon: {
        x: { align: "center", dx: -10 },
        y: { align: "bottom", dy: 0 },
        scale: 1.2,
        help: {
            x: { align: "right", dx: 19 },
            y: { align: "top", dy: 10 }
        }
    },

    text: {
        width: 130,
        x: { align: "right", dx: 0 },
        y: { align: "bottom", dy: -10 }
    },

    checkMark: {
        x: { align: "right", dx: -20 },
        y: { align: "top", dy: -10 }
    },

    simpleTextPos: {
        x: { align: "right", dx: -30 },
        y: { align: "bottom", dy: 5 }
    }
};
